import Vue from "vue";
import VueRouter from "vue-router";
import ProjectViewer from "@/views/ProjectViewer";
import SingleProject from "@/views/SingleProject";
import Login from "@/views/Login";
// import { PASSTHROUGH_ENV } from '@/utils/constants'
import { auth } from "@/providers/firebase";

// import Home from '../views/Home.vue'

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "ProjectViewer",
    component: ProjectViewer
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/projects/:slug",
    name: "SingleProject",
    component: SingleProject
  }
];

const router = new VueRouter({
  mode: process.env.VUE_APP_ROUTER_MODE,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path === "/login" || to.name === "Login") {
    // go on as normal
    next({ query: to.query });
  } else if (!auth.currentUser) {
    // redirect to login page
    const entry = to.path;
    next({ name: "Login", query: { to: entry, ...to.query } });
  } else {
    // go on as normal\
    next({ query: to.query });
  }
});

// router.beforeEach((to, from, next) => {
//   console.log(to, from, next)
//   if (to.name !== 'Login') {
//     if (auth.currentUser) {
//       console.log(1)
//       next()
//     } else {
//       console.log(2)
//       next({ name: 'Login' })
//     }
//   } else {
//     console.log(3)
//     next()
//   }

// })

export default router;
